import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';

export function useDeleteHealthcareFacilityLogo() {
  const queryClient = useQueryClient();

  return useMutation<void, AppMedError, number>({
    mutationFn: (facilityId: number) =>
      HealthcareFacilitiesApi.deleteLogo(facilityId),
    onSuccess: async (_data, facilityId) => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.healthcareFacility, facilityId.toString()],
      });
    },
  });
}
